import { Component, OnInit, HostListener } from '@angular/core';
import { HttpClient, HttpHeaders } from '@angular/common/http';
import { Router, ActivatedRoute } from '@angular/router';
import { GlobalsService } from '../common/services/globals.service';
import { SharedService } from '../common/services/shared.service';
import Stepper from 'bs-stepper';
import { PlatformLocation } from '@angular/common';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { Payment } from '../common/payment';
import { PaymentPayload, ACHPaymentDetailObj, CCPaymentDetailObj } from '../common/paymentpayload';
import { PaymentDetailObj } from '../common/paymentpayload';
import { CookieService } from "angular2-cookie/core";

@Component({
  selector: 'app-done',
  templateUrl: './done.component.html'
})
export class DoneComponent implements OnInit {

  constructor(
    private _global: GlobalsService,
    private formBuilder: FormBuilder,
    private sharedService: SharedService,
    private http: HttpClient,
    private router: Router,
    private route: ActivatedRoute,
    private location: PlatformLocation,
    private gservice: GlobalsService,
    private cookieService: CookieService
  ) {

  }

  app_Partner = {isFFM: false, partner: ''}

  ngOnInit() {
    // Maintain FFM status and partner logo details if user clicks on exit from FFM portal
    this.app_Partner.isFFM =  JSON.parse(localStorage.getItem('isFFM'));
    this.app_Partner.partner = localStorage.getItem('partner');
    localStorage.clear();
  }

}